import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { AudioPlayer } from '@/components/audio-player';
import { LIST_GAP_HORIZONTAL } from '@/styles';
import { OrderMetadata } from './types';
import { OriginalInboundTimestamps } from './original-inbound-timestamps';
import { processVoicemailSegments } from './utils';
import { StyleSheet, View } from 'react-native';
import { useAudioPlayer } from '@/hooks/use-audio-player';

interface Props {
  messageHeader?: React.ReactNode;
  onSelect?: (matchTerm: string) => void;
  order: OrderMetadata;
  selectedInputUUID?: string;
  showTranslation?: boolean;
}

export const OriginalInboundVoicemail: React.FC<Props> = ({
  onSelect,
  order,
  selectedInputUUID,
  showTranslation,
  messageHeader,
}) => {
  const audioSource = order.voicemailRecordingUrl || null;
  const audioPlayerState = useAudioPlayer(audioSource);

  const segments = useMemo(() => {
    return processVoicemailSegments(
      order,
      showTranslation ? i18n.locale : undefined,
    );
  }, [order, showTranslation]);

  if (!audioSource) {
    return null;
  }

  return (
    <>
      <View style={styles.audioPlayerContainer}>
        <AudioPlayer audioPlayerState={audioPlayerState} />
      </View>
      {messageHeader}
      <OriginalInboundTimestamps
        audioPlayerState={audioPlayerState}
        keyPrefix={order.smartOrderUUID}
        onSelect={
          onSelect
            ? (term, timestampMS) => {
                if (typeof timestampMS === 'number') {
                  audioPlayerState.setPosition(timestampMS);
                }
                onSelect(term);
              }
            : undefined
        }
        segments={segments}
        selectedInputUUID={selectedInputUUID}
      />
    </>
  );
};

export const styles = StyleSheet.create({
  audioPlayerContainer: {
    gap: 16,
    marginTop: LIST_GAP_HORIZONTAL,
  },
});
